import { IconType } from "@shared/enums/icon-type.enum";

export class Icon {
    constructor(
        public name: string,
        public type = IconType.MaterialDesign,
        public position: string = 'left'
    ){}
}
